// extracted by mini-css-extract-plugin
export var actionButton = "_b3-1";
export var actionButtons = "_b3-2";
export var actions = "_b3-0";
export var aiUnread = "_b3-10";
export var alignCenter = "_b3-h";
export var backWrapper = "_b3-3";
export var cellContainer = "_b3-4";
export var checkboxContainer = "_b3-5";
export var contentContainer = "_b3-6";
export var contentHeader = "_b3-8";
export var conversationsTableWrapper = "_b3-s";
export var draftReplyBadgeContainer = "_b3-m";
export var dropdownItem = "_b3-b";
export var dropdownItemsContainer = "_b3-a";
export var dropdownTitle = "_b3-c";
export var errorIcon = "_b3-7";
export var filter = "_b3-d";
export var gray = "_b3-i";
export var headerActionButtons = "_b3-e";
export var headerCheckboxContainer = "_b3-f";
export var icon = "_b3-j";
export var menuContainer = "_b3-k";
export var noMoreTicketsIcon = "_b3-12";
export var noMoreTicketsSubText = "_b3-13";
export var oneLine = "_b3-l";
export var optionsButton = "_b3-n";
export var plus = "_b3-o";
export var portalButtonsWrapper = "_b3-g";
export var red = "_b3-p";
export var scrolledTop = "_b3-9";
export var search = "_b3-q";
export var selectedConversationsCount = "_b3-r";
export var spinner = "_b3-t";
export var strong = "_b3-u";
export var summaryCell = "_b3-v";
export var tableContainer = "_b3-11";
export var tagContainer = "_b3-w";
export var threeDots = "_b3-x";
export var twoLines = "_b3-y";
export var unread = "_b3-z";